import React from 'react';
import styles from '../style/style.scss';
import { CenaIcon, DomekIcon, FlagaIcon, KulkiIcon, WinoBuzkaIcon, WinogronaIcon, WinoIcon } from './MenuIcons';

import domIcon from '../images/menu/dom.png';
import kolorIcon from '../images/menu/kolor.png';
import winogronaIcon from '../images/menu/winogrona.png';
import cenaIcon from '../images/menu/cena.png';
import kieliszkiIcon from '../images/menu/kieliszki.png';
import flagaIcon from '../images/menu/flaga.png';
import butelkaIcon from '../images/menu/butelka.png';

import domActiveIcon from '../images/menu/dom_active.png';
import kolorActiveIcon from '../images/menu/kolor_active.png';
import winogronaActiveIcon from '../images/menu/winogrona_active.png';
import cenaActiveIcon from '../images/menu/cena_active.png';
import kieliszkiActiveIcon from '../images/menu/kieliszki_active.png';
import flagaActiveIcon from '../images/menu/flaga_active.png';
import butelkaActiveIcon from '../images/menu/butelka_active.png';

const IconsMap = [
  [domIcon, domActiveIcon], // 0
  [kolorIcon, kolorActiveIcon], // 1
  [winogronaIcon, winogronaActiveIcon], // 2
  [cenaIcon, cenaActiveIcon], // 3
  [kieliszkiIcon, kieliszkiActiveIcon], // 4
  [flagaIcon, flagaActiveIcon], // 5
  [butelkaIcon, butelkaActiveIcon], // 6
];

function MenuItem({
  goToQuestion,
  activeQuestionId,
  id,
}: {
  goToQuestion(qId: number): void;
  activeQuestionId: number;
  id: number;
}) {
  const isActive = activeQuestionId == id;
  const iconsrc = IconsMap[id][isActive ? 1 : 0];
  return (
    <div className={styles.btn} onClick={() => goToQuestion(id)}>
      <img src={iconsrc} alt="menubtn" style={{ width: '100%' }} />
    </div>
  );
}

function RightMenu({ goToQuestion, activeQuestionId }: { goToQuestion(qId: number): void; activeQuestionId: number }) {
  const buildClass = (id: number) => {
    const isActive = activeQuestionId == id;
    return isActive ? `${styles.btn} ${styles.btnActive}` : styles.btn;
  };
  return (
    <div className={styles.rightmenu}>
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={0} />
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={1} />
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={2} />
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={3} />
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={4} />
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={5} />
      <MenuItem goToQuestion={goToQuestion} activeQuestionId={activeQuestionId} id={6} />
    </div>
  );
}

export default RightMenu;
